import { Component, Vue } from 'vue-property-decorator'
import NavBar from '../components/nav-bar/nav-bar.vue'
import SideBar from '../components/side-bar/side-bar.vue'
import FooterBar from '../components/footer-bar/footer-bar.vue'

@Component({
  components: {
    NavBar,
    SideBar,
    FooterBar
  }
})

export default class Default extends Vue {

  private sidebarExpanded: boolean = true;

  toggleSidebar () {

    this.sidebarExpanded = !this.sidebarExpanded;
  }
}